
import { useParams, useNavigate } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { Button } from "@/components/ui/button";
import { ArrowLeft } from "lucide-react";
import { PostsManager } from "@/components/settings/admin/PostsManager";
import { toast } from "@/hooks/use-toast";
import { useRecepcionistaRedirect } from "@/hooks/useRecepcionistaRedirect";

const GestionNoticias = () => {
  const { gymId } = useParams();
  const navigate = useNavigate();
  const { isRecepcionista } = useRecepcionistaRedirect();

  const { data: gym } = useQuery({
    queryKey: ["gym", gymId],
    queryFn: async () => {
      if (!gymId) {
        toast({
          variant: "destructive",
          title: "Error",
          description: "No se encontró el gimnasio especificado",
        });
        navigate("/configuracion?tab=admin&subtab=gym");
        return null;
      }

      const { data, error } = await supabase
        .from("gyms")
        .select("*")
        .eq("id", gymId)
        .single();

      if (error) {
        console.error("Error fetching gym:", error);
        toast({
          variant: "destructive",
          title: "Error",
          description: "No se pudo cargar la información del gimnasio",
        });
        throw error;
      }

      return data;
    },
    enabled: !!gymId,
  });

  if (!gymId) {
    return null;
  }

  return (
    <div className="min-h-screen pt-16 bg-background text-primary">
      <header className="border-b border-border">
        <div className="container py-4">
          <Button
            variant="ghost"
            onClick={() => navigate(isRecepcionista ? "/recepcionista" : "/configuracion?tab=admin&subtab=gym")}
            className="mb-4 text-primary hover:bg-primary/10"
          >
            <ArrowLeft className="mr-2 h-4 w-4" />
            {isRecepcionista ? "Volver al Panel" : "Volver"}
          </Button>
          <h1 className="text-2xl font-heading font-bold text-primary">
            Gestión de Noticias - {gym?.name}
          </h1>
        </div>
      </header>
      <main className="container py-6">
        <PostsManager gymId={gymId} />
      </main>
    </div>
  );
};

export default GestionNoticias;
